module.exports = __webpack_public_path__ + "img/up10.0068102d.png";